import script from "./HeaderHero.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderHero.vue?vue&type=script&setup=true&lang=js"

import "./HeaderHero.vue?vue&type=style&index=0&id=3f4fed2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4fed2e"]])

export default __exports__